exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3ruc-0kZyUxAbsN41jMacH {\n  margin-bottom: 4px;\n}\n", ""]);

// exports
exports.locals = {
	"label": "_3ruc-0kZyUxAbsN41jMacH"
};


//////////////////
// WEBPACK FOOTER
// /Users/smotley795/Source/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/Users/smotley795/Source/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/components/Common/FormMUIWrapperComponents/CustomSingleSelectComboBox/CustomSingleSelectComboBox.css
// module id = 10595
// module chunks = 23